import React from 'react'
import theme from './theme/index'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { ApolloProvider } from '../../src/providers/index'

const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {element}
      </MuiThemeProvider>
    </ApolloProvider>
  )
}

export default wrapRootElement
